import m from "mithril";

/**
 * Category pill.
 *
 * Long names are capped by `.category-tag`'s max-width and truncated with an
 * ellipsis. Clicking a truncated tag expands it to show the full name; clicking
 * it again collapses it. Expansion is click-driven rather than hover-driven on
 * purpose: growing the tag reflows its siblings, and under :hover that shifts
 * the tag out from under the cursor, which oscillates.
 *
 * Attrs:
 *   label — text to display (already translated by the caller)
 *   class — extra classes, e.g. the standard-category colour or "category-custom"
 */
const CategoryTag = {
    oninit: function () {
        this.expanded = false;
        this.truncated = false;
    },
    // Only a tag whose text actually overflows is worth expanding, so measure
    // after every draw and remember it for the cursor/click handling below.
    measure: function (vnode) {
        const el = vnode.dom;
        const truncated = el.scrollWidth > el.clientWidth;
        if (truncated !== vnode.state.truncated) {
            vnode.state.truncated = truncated;
            m.redraw();
        }
    },
    oncreate: function (vnode) { vnode.state.measure(vnode); },
    onupdate: function (vnode) { vnode.state.measure(vnode); },
    view: function (vnode) {
        const self = this;
        const label = vnode.attrs.label;
        const interactive = self.expanded || self.truncated;

        return m("span.category-tag", {
            class: (vnode.attrs.class || "") + (self.expanded ? " expanded" : "") + (interactive ? " c-hand text-dark" : ""),
            title: label,
            onclick: function (e) {
                // Nothing to reveal — let the click reach whatever wraps the tag
                // (course cards and table rows are clickable).
                if (!interactive) return;
                e.stopPropagation();
                self.expanded = !self.expanded;
            }
        }, label);
    }
};

export default CategoryTag;
